var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',{staticClass:"w-100"},[_c('CCol',{attrs:{"md":"12","lg":"12","sm":"12","xs":"12"}},[(_vm.page == 'home')?_c('HomeProceesVue',{on:{"changePage":_vm.changePage,"setView":_vm.setView}}):_vm._e(),(_vm.page == 'payments')?_c('PaymentsVue',{staticClass:"pt-1",on:{"mtdBack":_vm.mtdBack}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }